import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalUpdateEmployeeShowPaymentsDocument = gql`
  mutation SalesPortalUpdateEmployeeShowPayments(
    $chatEmployeeUUID: uuid!
    $showAppPaymentsTab: Boolean!
  ) {
    update_chats_employees_by_pk(
      pk_columns: { uuid: $chatEmployeeUUID }
      _set: { show_app_payments_tab: $showAppPaymentsTab }
    ) {
      show_app_payments_tab
      uuid
    }
  }
`;
export type SalesPortalUpdateEmployeeShowPaymentsMutationFn =
  Apollo.MutationFunction<
    Types.SalesPortalUpdateEmployeeShowPaymentsMutation,
    Types.SalesPortalUpdateEmployeeShowPaymentsMutationVariables
  >;
export function useSalesPortalUpdateEmployeeShowPaymentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalUpdateEmployeeShowPaymentsMutation,
    Types.SalesPortalUpdateEmployeeShowPaymentsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalUpdateEmployeeShowPaymentsMutation,
    Types.SalesPortalUpdateEmployeeShowPaymentsMutationVariables
  >(SalesPortalUpdateEmployeeShowPaymentsDocument, options);
}
export type SalesPortalUpdateEmployeeShowPaymentsMutationHookResult =
  ReturnType<typeof useSalesPortalUpdateEmployeeShowPaymentsMutation>;
export type SalesPortalUpdateEmployeeShowPaymentsMutationResult =
  Apollo.MutationResult<Types.SalesPortalUpdateEmployeeShowPaymentsMutation>;
export type SalesPortalUpdateEmployeeShowPaymentsMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalUpdateEmployeeShowPaymentsMutation,
    Types.SalesPortalUpdateEmployeeShowPaymentsMutationVariables
  >;
